import styled from 'styled-components';

// Utils
import { Link } from 'react-router-dom';

export const Menu = styled.nav`
  margin-right: -30px;
  @media (max-width: 920px) {
    margin-right: 0;
    margin-top: 6px;
  }
`;

export const StyledLink = styled(Link)`
  padding: 30px;
  font-size: 20px;
  font-weight: 500;
  color: var(--theme-palette-links-secondary-color);
  transition: var(--transition);

  &:hover {
    color: var(--theme-palette-links-secondary-color-hover);
  }

  @media (max-width: 900px) {
    font-weight: 600;
    display: block;
    padding: 12px;
    text-align: center;
    font-size: 16px;
  }
`;
